<div [style]="getContainerRating()" >
<span [style]="getStyleSizeFont()">{{name}}</span>
<div class="progress" [style]="getStyleSize()">
  <div class="progress-bar" role="progressbar" [style]="getClass()"></div>
</div>
  <span [style]="getStyleSizeRating()">{{rating | number : '1.1'}}</span>
</div>
